export const X_AUTH_TOKEN = 'cat-x-auth-token'
export const X_AUTH_TOKEN_EXPIRES_IN = 604800 * 4 // 4 weeks
export const X_AUTH_TOKEN_SHORT_EXPIRES_IN = 300 // 5 minutes

export const DATE_FORMAT = 'yyyy-MM-dd'
export const DATE_TIME_FORMAT = 'yyyy-MM-dd H:mm:ss'
